import { useTranslation } from "react-i18next";
import { PageProps } from "../../models/routing.model";
import { useNavigate, useParams } from "react-router-dom";
import UiPageLayout from "../../components/page-layout/PageLayout.component";
import UiButton from "../../components/button/Button";
import { getLocalStorageUser } from "../../services/session/auth.service";
import { HealthReportAction } from "../../models/pages/health-report.model";

const HealthReportConfirmation = (_props: PageProps) => {
	const { t } = useTranslation("common");
	const urlParams = useParams<{ action: HealthReportAction }>();
	const navigate = useNavigate();

	return (
		<UiPageLayout
			title="HEALTH_REPORT.TITLE"
			className="health-report-confirmation-container"
			leftChildren={
				<div>
					<h3>
						{urlParams.action === HealthReportAction.EMAIL
							? t("HEALTH_REPORT.CONFIRMATION_MSG", {
								email: getLocalStorageUser().emails.find((x) => x.isPrimary)
									?.emailAddress,
							})
							: t("HEALTH_REPORT.CONFIRMATION_MSG2")}
					</h3>

					<UiButton
						label="HEALTH_REPORT.CONFIRMATION_LINK"
						onClick={(_e) => navigate("/track-health", { replace: true })}
					/>
				</div>
			}
		/>
	);
};
export default HealthReportConfirmation;
